module.exports = __webpack_public_path__ + "static/idea-27fb8b0e1cd4317b9eed6c24c1cb0fef.svg";